import { useMemo } from 'react';
import {
  THIS_WEEK,
  NEXT_WEEK,
  LAST_WEEK,
  THIS_MONTH,
  NEXT_MONTH,
  LAST_MONTH,
  THIS_QUARTER,
  NEXT_QUARTER,
  LAST_QUARTER,
  THIS_YEAR,
  LAST_YEAR,
  CUSTOM_RANGE,
  LAST_THIRTY_DAYS
} from '@constants/Kendo/rangeOptions';
import { hasGlobalTerritoriesApplied } from '@helpers/territories';
import { actionTypes } from '../reducer';
import FilterTypes from '../../../../constants/FilterTypes.ts';

export default function useFilters(filters, dispatch) {
  const globalTerritoriesApplied = hasGlobalTerritoriesApplied();

  const onChangeSearchFilter = (fieldName) => {
    return (e) => {
      dispatch({ type: actionTypes.FILTER_CHANGED, field: fieldName, value: e.sender.element[0].value });
    };
  };

  const handleMultiSelectFilterChange = (fieldName) => {
    return (value) => {
      dispatch({ type: actionTypes.FILTER_CHANGED, field: fieldName, value });
    };
  };

  const onToggleFilter = (fieldName) => {
    return () => {
      dispatch({ type: actionTypes.FILTER_TOGGLED, field: fieldName });
    };
  };

  const onChangeDateFilter = (fieldName) => {
    return (dateFieldName, value) => {
      dispatch({ type: actionTypes.IS_LOADING });

      dispatch({
        type: actionTypes.DATE_RANGE_FILTER_CHANGED,
        field: fieldName,
        dateField: dateFieldName,
        value
      });
    };
  };

  return useMemo(() => {
    const list = [
      {
        field: 'account',
        locale: 'account',
        type: FilterTypes.GenericMultiSelect,
        active: filters.active.account,
        value: filters.values.account,
        onChange: handleMultiSelectFilterChange('account'),
        onToggle: onToggleFilter('account')
      },
      {
        field: 'building',
        locale: 'building',
        type: FilterTypes.GenericMultiSelect,
        active: filters.active.building,
        value: filters.values.building,
        onChange: handleMultiSelectFilterChange('building'),
        onToggle: onToggleFilter('building')
      },
      {
        field: 'issueDate',
        locale: 'issue_date',
        type: 'dateRangePicker',
        active: true,
        locked: true,
        dateRanges: [
          THIS_WEEK,
          NEXT_WEEK,
          LAST_WEEK,
          THIS_MONTH,
          NEXT_MONTH,
          LAST_MONTH,
          LAST_THIRTY_DAYS,
          THIS_QUARTER,
          NEXT_QUARTER,
          LAST_QUARTER,
          THIS_YEAR,
          LAST_YEAR,
          CUSTOM_RANGE
        ],
        values: {
          rangeType: filters.values.issueDate.rangeType,
          startDate: filters.values.issueDate.startDate,
          endDate: filters.values.issueDate.endDate
        },
        onChange: onChangeDateFilter('issueDate'),
        onToggle: onToggleFilter('issueDate')
      },
      {
        field: 'technician',
        locale: 'technician',
        type: FilterTypes.GenericMultiSelect,
        active: filters.active.technician,
        value: filters.values.technician,
        onChange: handleMultiSelectFilterChange('technician'),
        onToggle: onToggleFilter('technician'),
        allowLetterAvatar: true
      },
      {
        field: 'technicianTeam',
        locale: 'technician_team',
        type: FilterTypes.GenericMultiSelect,
        active: filters.active.technicianTeam,
        value: filters.values.technicianTeam,
        onChange: handleMultiSelectFilterChange('technicianTeam'),
        onToggle: onToggleFilter('technicianTeam')
      },
      {
        field: 'invoiceCategory',
        locale: 'invoice_category',
        type: 'searchSelect',
        active: filters.active.invoiceCategory,
        value: filters.values.invoiceCategory,
        onChange: onChangeSearchFilter('invoiceCategory'),
        onToggle: onToggleFilter('invoiceCategory')
      }
    ];

    if (!globalTerritoriesApplied) {
      list.push({
        field: 'territory',
        locale: 'territory',
        type: FilterTypes.GenericMultiSelect,
        active: filters.active.territory,
        value: filters.values.territory,
        withUnassigned: true,
        onChange: handleMultiSelectFilterChange('territory'),
        onToggle: onToggleFilter('territory')
      });
    }

    return list;
  }, [filters, globalTerritoriesApplied]);
}
